module.exports = "/_next/static/images/christopher-warren@2x-9166c9ee55723c3cf1d6a6346460e350.png";